import Env from '../../environmentVariables/EnvironmentVariables';

export const FEE_STRATEGY_TARGET_PERCENTILE =
	Env.dynamicFeeTargetPercentile ?? 0;
export const FEE_SUBSCRIPTION_SLOT_LOOKBACK = 10;

export const BOOSTED_MULITPLIER = 5;
export const TURBO_MULTIPLIER = 10;
